<template>
  <div>
    <v-card>
      <v-card-title>
        <v-layout wrap justify-space-between align-center>
          <v-flex xs12 md6>
            <span class="display-1">Consulta de Atualizações</span>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text v-for="(item, index) in items" :key="index">
        <div :class="{ 'custom-v-card-text': !item.visualizada }">
          <v-layout wrap justify-space-between align-center>
            <span class="headline font-weight-bold">
              {{ item.atualizacao.titulo }}
            </span>

            <v-spacer></v-spacer>

            <v-btn flat icon color="blue">
              <v-tooltip v-if="item.visualizada" top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    @click="
                      () => {
                        editedItem.atualizacao_id = item.id;
                        save(item.id);
                      }
                    "
                    v-on="on"
                  >
                    visibility
                  </v-icon>
                </template>
                <span>Marcar como não visualizada</span>
              </v-tooltip>
              <v-tooltip v-else top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    @click="
                      () => {
                        editedItem.visualizada = true;
                        editedItem.user_id = $auth.user().id;
                        editedItem.atualizacao_id = item.id;
                        save(item.id);
                      }
                    "
                    v-on="on"
                  >
                    visibility_off
                  </v-icon>
                </template>
                <span>Marcar como visualizada</span>
              </v-tooltip>
            </v-btn>

            <v-chip color="grey darken-1" text-color="white">
              {{ formatarData(item.atualizacao.data_hora) }}
            </v-chip>
          </v-layout>
          <div class="caption" v-html="item.atualizacao.descricao"></div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>
tr td:last-child {
  min-width: 130px;
}

.fab-container {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 10;
}

.custom-v-card-text {
  /* Estilo para itens não visualizados */
  background-color: rgba(46, 125, 50, 0.2);
  border: 1px solid rgb(46, 125, 50);
  border-radius: 5px;
  padding: 10px; /* Espaçamento interno */
  margin-bottom: 10px; /* Margem inferior */
}
</style>

<script>
import crud from "../../mixin/crud";

export default {
  mixins: [crud],
  data: () => ({
    entity: "atualizacao_user",
  }),
  mounted() {
    // Adicionar um listener para o evento
    this.$parent.$on("dialog_opened", this.initialize());
  },
  beforeDestroy() {
    // Remover o listener quando o componente for destruído para evitar vazamentos de memória
    this.$parent.$off("dialog_opened", this.executarEvento);
  },
  methods: {
    executarEvento() {
      // Lógica a ser executada quando o evento for acionado
      console.log("Evento acionado no componente filho");
    },
    formatarData(dataHora) {
      const data = this.moment(dataHora).format("DD/MM/YYYY - HH:mm:ss");
      return data.toLocaleString();
    },
    save(id = this.editedItem.id, data = this.editedItem) {
      if (this.saving) return;
      this.saving = true;
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.saving = false;
          this.$store.commit("snackbar/change_values", {
            text: "Por favor, corrija as validações antes de salvar!",
            color: "error",
            dialog: true,
          });
        } else {
          // this.$store.commit("loader/change_dialog", true);

          this.$http
            .put(`api/${this.entity}/${id}`, data)
            .then(
              (res) => {
                console.log("id", id);
                console.log("data", data);
                let item = this.items.find((item) => {
                  return item["id"] == res.body.dados["id"];
                });
                console.log("item", item);
                Object.assign(item, res.body.dados);
                this.resBody = res.body;

                this.$store.commit("snackbar/change_values", {
                  text: `Registro de Atualização ${
                    this.view == 2 ? "incluído" : "editado"
                  } com sucesso!`,
                  color: "success",
                  dialog: true,
                });
              },
              (err) => {
                this.$store.commit("snackbar/change_values", {
                  text: `Não foi possível ${
                    this.view == 2 ? "incluir" : "editar"
                  } o registro de Atualização, reporte o erro.`,
                  color: "error",
                  dialog: true,
                });
              }
            )
            .finally(() => {
              this.saving = false;
              // this.$store.commit("loader/change_dialog", false);
              this.close();
            });
        }
      }, () => {
        this.saving = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/crud/AtualizacaoUser.vue